/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onSlideChange = /* GraphQL */ `subscription OnSlideChange {
  onSlideChange {
    id
    url
    sequence
    type
    pollId
    pollResults {
      option
      percentage
      voteCount
      __typename
    }
    collateralTypeId
    currentOffset
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnSlideChangeSubscriptionVariables,
  APITypes.OnSlideChangeSubscription
>;
export const onMeetingStatusChange = /* GraphQL */ `subscription OnMeetingStatusChange {
  onMeetingStatusChange {
    eventid
    meetingstatusflag
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnMeetingStatusChangeSubscriptionVariables,
  APITypes.OnMeetingStatusChangeSubscription
>;
export const onSlideControlToggle = /* GraphQL */ `subscription OnSlideControlToggle {
  onSlideControlToggle {
    eventid
    enableSlideControl
    email
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnSlideControlToggleSubscriptionVariables,
  APITypes.OnSlideControlToggleSubscription
>;
export const onDragSlideForSequence = /* GraphQL */ `subscription OnDragSlideForSequence {
  onDragSlideForSequence {
    eventid
    isDragging
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDragSlideForSequenceSubscriptionVariables,
  APITypes.OnDragSlideForSequenceSubscription
>;
export const onHostChatMessage = /* GraphQL */ `subscription OnHostChatMessage($webinarId: String!) {
  onHostChatMessage(webinarId: $webinarId) {
    id
    webinarId
    senderId
    senderName
    senderEmail
    senderRole
    channel
    targetUserId
    targetUserName
    message
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnHostChatMessageSubscriptionVariables,
  APITypes.OnHostChatMessageSubscription
>;
export const onQuestionAsked = /* GraphQL */ `subscription OnQuestionAsked($webinarId: String!) {
  onQuestionAsked(webinarId: $webinarId) {
    id
    webinarId
    askerId
    askerName
    askerRole
    body
    isAnonymous
    status
    isPinned
    isHighlighted
    isPublic
    upvoteCount
    answers {
      id
      responderId
      responderName
      responderEmail
      responderRole
      body
      isLiveAnswer
      createdAt
      __typename
    }
    answeredBy
    answeredByName
    answerType
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnQuestionAskedSubscriptionVariables,
  APITypes.OnQuestionAskedSubscription
>;
export const onQuestionUpdated = /* GraphQL */ `subscription OnQuestionUpdated($webinarId: String!) {
  onQuestionUpdated(webinarId: $webinarId) {
    id
    webinarId
    askerId
    askerName
    askerRole
    body
    isAnonymous
    status
    isPinned
    isHighlighted
    isPublic
    upvoteCount
    answers {
      id
      responderId
      responderName
      responderEmail
      responderRole
      body
      isLiveAnswer
      createdAt
      __typename
    }
    answeredBy
    answeredByName
    answerType
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnQuestionUpdatedSubscriptionVariables,
  APITypes.OnQuestionUpdatedSubscription
>;
export const onCustomChatQnaToggle = /* GraphQL */ `subscription OnCustomChatQnaToggle {
  onCustomChatQnaToggle {
    eventid
    enableCustomChatQna
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCustomChatQnaToggleSubscriptionVariables,
  APITypes.OnCustomChatQnaToggleSubscription
>;
